import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchCoursesQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type FetchCoursesQuery = (
  { __typename: 'Query' }
  & { courseInstances: (
    { __typename: 'PaginatedCourseInstance' }
    & Pick<SchemaTypes.PaginatedCourseInstance, 'count'>
    & { items: Array<(
      { __typename: 'CourseInstance' }
      & Pick<SchemaTypes.CourseInstance, 'id' | 'name' | 'description'>
    )> }
  ) }
);


export const FetchCoursesDocument = /*#__PURE__*/ gql`
    query FetchCourses($companyId: ObjectID!) {
  courseInstances(companyId: $companyId) {
    count
    items {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useFetchCoursesQuery__
 *
 * To run a query within a React component, call `useFetchCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCoursesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCoursesQuery(baseOptions: Apollo.QueryHookOptions<FetchCoursesQuery, FetchCoursesQueryVariables> & ({ variables: FetchCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCoursesQuery, FetchCoursesQueryVariables>(FetchCoursesDocument, options);
      }
export function useFetchCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCoursesQuery, FetchCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCoursesQuery, FetchCoursesQueryVariables>(FetchCoursesDocument, options);
        }
export function useFetchCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCoursesQuery, FetchCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCoursesQuery, FetchCoursesQueryVariables>(FetchCoursesDocument, options);
        }
export type FetchCoursesQueryHookResult = ReturnType<typeof useFetchCoursesQuery>;
export type FetchCoursesLazyQueryHookResult = ReturnType<typeof useFetchCoursesLazyQuery>;
export type FetchCoursesSuspenseQueryHookResult = ReturnType<typeof useFetchCoursesSuspenseQuery>;
export type FetchCoursesQueryResult = Apollo.QueryResult<FetchCoursesQuery, FetchCoursesQueryVariables>;